import * as React from 'react';
import { observer } from 'mobx-react';
import { Step } from '../common/Step';
import { StepText } from '../common/StepText';
import { StepSection } from '../common/StepSection';
import { FormButtonWrapper } from '../common/FormButtonWrapper';
import { Button } from '../../../commonv2/components/Button';
import { GlobalLoader } from '../../components/GlobalLoader';
import { UserInfoConfirmation } from '../common/userInfo/UserInfoConfirmation';
import './confirmationStep.module.scss';
import { CardPaymentConfirmation } from '../common/payment/CardPaymentConfirmation';
import { EventReservationPageState } from './states/EventReservationPageState';
import { EventSummary } from './components/EventSummary';
import { CheckBox } from '@sheinc/design-system';

type Props = {
    pageState: EventReservationPageState;
};

@observer
export class ConfirmationStep extends React.Component<Props> {
    render() {
        const { pageState } = this.props;
        const {
            event: eventResource,
            reservationNote,
            appliedPrice,
            privacyPolicyAgreed,
            togglePrivacyPolicyAgreed,
        } = pageState;
        if (eventResource.isEmpty()) {
            throw new Error("InputStep shouldn't be rendered before initialization complete");
        }
        const event = eventResource.get();
        const needPayment = appliedPrice > 0;
        return (
            <Step>
                <StepSection title="予約情報の確認" styleName="section">
                    <EventSummary event={event} appliedPrice={appliedPrice} />
                </StepSection>
                {pageState.userForm.needUserInput() && (
                    <StepSection title="会員情報" styleName="section">
                        <UserInfoConfirmation state={pageState.userForm} />
                    </StepSection>
                )}
                <StepSection title="イベントについてのご質問" styleName="section">
                    <StepText>{reservationNote.value}</StepText>
                </StepSection>
                {needPayment && (
                    <StepSection title="お支払い方法" styleName="section">
                        <CardPaymentConfirmation
                            state={pageState.paymentMethodForm}
                            priceWithoutTax={event.price}
                            priceWithTax={event.price_with_tax}
                            onModificationRequested={() => pageState.goBackToInput()}
                        />
                    </StepSection>
                )}
                {event.note && (
                    <StepSection title="備考" styleName="section">
                        <StepText>{event.note}</StepText>
                    </StepSection>
                )}
                {needPayment && (
                    <StepSection title="キャンセルについて">
                        <StepText>
                            イベント開催２週間前からキャンセル料が発生するため、ご注意ください。<br />
                            <br />
                            キャンセル料に関しては以下です。<br />
                            開催日14日前～8日前まで：受講料の50％<br />
                            開催日7日前～前々日まで：受講料の80％<br />
                            開催日の前日以降：受講料の100％<br />
                        </StepText>
                    </StepSection>
                )}
                <div styleName="privacy-policy-note">
                    <div styleName="note">
                        <a styleName="link" target="_blank" href="https://she-inc.jp/common/policy.html">
                            プライバシーポリシー
                        </a>にご同意いただける場合は、「同意する」にチェックを付け、お申込を確定してください
                    </div>
                    <div styleName="check-box-wrapper">
                        <CheckBox checked={privacyPolicyAgreed} onCheck={togglePrivacyPolicyAgreed}>
                            <>
                                <a styleName="link" target="_blank" href="https://she-inc.jp/common/policy.html">
                                    プライバシーポリシー
                                </a>に同意する
                            </>
                        </CheckBox>
                    </div>
                </div>
                <FormButtonWrapper>
                    <Button
                        type="primary"
                        disabled={!privacyPolicyAgreed || pageState.processing}
                        onClick={() => pageState.submit()}
                    >
                        確定する
                    </Button>
                </FormButtonWrapper>
                {pageState.processing && <GlobalLoader />}
            </Step>
        );
    }
}
